import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const LABELS = {
  onlyfans: "OnlyFans",
  justforfans: "JustForFans",
  faphouse: "Faphouse",
};

export default function PlatformSessionPanel({ platform }) {
  const [signal, setSignal] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);

    try {
      const { data } = await api.get("/api/platform-data/connection-status");
      setSignal(
        data.platforms?.find((item) => item.platform === platform) || null
      );
      setError("");
    } catch {
      setError("Connection status is unavailable. Retry when the service is ready.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [platform]); // eslint-disable-line react-hooks/exhaustive-deps

  const connected = signal?.state === "connected";

  return (
    <section
      className="my-4 rounded-lg border border-zinc-800 bg-zinc-950/60 p-4"
      data-testid={`extension-session-${platform}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-semibold">
          {LABELS[platform]} browser-extension connection
        </h3>

        <span
          role="status"
          className={
            connected
              ? "text-emerald-300 text-sm"
              : "text-amber-300 text-sm"
          }
        >
          {loading
            ? "Checking session…"
            : connected
            ? "Connected"
            : signal?.state === "needs_reauth"
            ? "Reconnect via extension"
            : "Session not verified"}
        </span>
      </div>

      <p className="mt-2 text-sm text-zinc-400">
        Open your signed-in creator page with the GioPilos extension. Only visible
        page data and a safe session-status signal are synced; platform credentials
        stay in your browser.
      </p>

      {signal?.last_verified_at && (
        <p className="mt-2 text-xs text-zinc-500">
          Last verified: {new Date(signal.last_verified_at).toLocaleString()}
        </p>
      )}

      {error && (
        <p role="alert" className="mt-2 text-sm text-amber-300">
          {error}
        </p>
      )}

      <div className="mt-3 flex flex-wrap gap-3 text-sm">
        <a
          className="text-sky-300 underline"
          href={`/crm/settings?tab=connections&platform=${platform}`}
        >
          Connect / Reconnect via extension
        </a>

        <button
          type="button"
          disabled={loading}
          onClick={refresh}
          className="text-zinc-300 underline disabled:opacity-50"
        >
          Refresh status
        </button>
      </div>
    </section>
  );
}